export const canAutoplay = () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)').matches;

  return !prefersReducedMotion;
};
